import Image from 'next/image';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faRightToBracket, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import styles from './condition-guide.module.scss';
import translationFallback from '@/utilites/translations/translationFallback';
import { useTranslation } from 'next-i18next';
import originalCapImage from '@/public/images/condition-guide/original_cap.webp';
import conditionImage from '@/public/images/condition-guide/condition.webp';
import magazineImage from '@/public/images/condition-guide/magazine.webp';
import neckImage from '@/public/images/condition-guide/neck.webp';
import ninelabelImage from '@/public/images/condition-guide/ninelabel.webp';
import sealImage from '@/public/images/condition-guide/seal.webp';
import whiskeyFriendly from '@/public/images/condition-guide/whiskeyfriendly.webp';
import packagingImage from '@/public/images/condition-guide/packaging.webp';
import greenTick from '@/public/images/condition-guide/greenTick.svg';
import mainBannerImage from '@/public/images/condition-guide/mainBanner.webp';
import { useRouter } from 'next/router';

import Head from 'next/head';
import Accordion from 'react-bootstrap/Accordion';
import useBackendUser from '@/hooks/useBackendUser';
import getBasicStaticSideProps from '@/lib/staticSideProps/getBasicStaticSideProps';
function Authenticating() {
  const { t } = useTranslation('condition_guide');
  const { t: tCommon } = useTranslation('common');
  const { data: user } = useBackendUser();
  const router = useRouter();
  return (
    <>
      <Head>
        <title>
          {translationFallback(
            'condition_guide_title',
            tCommon('condition_guide_title'),
            'Condition guide'
          )}
        </title>
        <meta
          name="description"
          content={translationFallback(
            'condition_guide_description',
            tCommon('condition_guide_description'),
            'Every bottle sold on Spiritory must be in brand new and mint condition - including the presentation box, seal, all labels and the filling level'
          )}
        />
      </Head>
      <div className={styles.mainContainer}>
        <div
          className={`bg-blue-gradient g-0 d-flex flex-md-row flex-column justify-content-md-center mw-auto mh-auto align-items-center ${styles.mainSection}`}
        >
          <div
            className={`d-flex align-items-center justify-content-between h-100 ${styles.mainText}`}
          >
            <div className={`d-flex align-items-start gap-3 ${styles.mainTextContainer}`}>
              <div className={styles.hideMobile}>
                <Image
                  src="/images/condition-guide/icon.png"
                  alt="tag-icon"
                  width="57"
                  height="57"
                  style={{
                    objectFit: 'contain',
                    position: 'relative',
                    bottom: 5,
                  }}
                />
              </div>
              <div className={`${styles.hideDesktop} d-flex flex-column align-items-center gap-2`}>
                <div className="d-flex align-items-center gap-2" style={{ maxWidth: 450 }}>
                  <div>
                    <Image
                      src="/images/condition-guide/icon.png"
                      alt="tag-icon"
                      width="57"
                      height="57"
                      style={{
                        objectFit: 'contain',
                        position: 'relative',
                        bottom: 5,
                      }}
                    />
                  </div>
                  <div>
                    <h1 className="h2 p-0 m-0">
                      {translationFallback(
                        'conditionGuidelinesTitle',
                        t('conditionGuidelinesTitle'),
                        'Condition guidelines'
                      )}
                    </h1>
                  </div>
                </div>
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faCheck} className="text-primary" />
                    <p className="font-size-20 lh-23 p-0 m-0">
                      {translationFallback(
                        'qualityMaintenanceDescription',
                        t('qualityMaintenanceDescription'),
                        'At Spiritory, we maintain consistent quality by following guidelines for the condition of all bottles sold on our platform.'
                      )}
                    </p>
                  </div>
                </div>
                <div
                  className={`d-flex align-items-center justify-content-between flex-wrap mt-3 ${styles.buttonContainer}`}
                  style={{ width: '100%' }}
                >
                  <div
                    style={{ width: '48%' }}
                    onClick={() => {
                      if (user) {
                        router.push('/dashboard');
                      } else {
                        router.push('/auth/sign-in');
                      }
                    }}
                  >
                    <button
                      className={`d-flex align-items-center gap-2 btn btn-s-outline-primary px-7`}
                      style={{ padding: '0.7rem 0' }}
                      type="button"
                    >
                      <span>
                        <FontAwesomeIcon icon={faRightToBracket} />
                      </span>
                      {translationFallback('logInButton', t('logInButton'), 'Log In')}
                    </button>
                  </div>
                  <div
                    style={{ width: '48%' }}
                    onClick={() => {
                      if (user) {
                        router.push('/dashboard');
                      } else {
                        router.push('/auth/sign-up');
                      }
                    }}
                  >
                    <button
                      className={`d-flex align-items-center gap-2 btn btn-s-primary px-7`}
                      style={{ padding: '0.7rem 0' }}
                      type="button"
                    >
                      <span>
                        <FontAwesomeIcon icon={faUserPlus} />
                      </span>
                      {translationFallback('signUpButton', t('signUpButton'), 'Sign Up')}
                    </button>
                  </div>
                </div>
              </div>
              <div className={`d-flex flex-column align-items-start gap-2 ${styles.hideMobile}`}>
                <h1 className="h2 p-0 m-0">
                  {translationFallback(
                    'conditionGuidelinesTitle',
                    t('conditionGuidelinesTitle'),
                    'Condition guidelines'
                  )}
                </h1>
                <div>
                  <div className="d-flex align-items-center gap-2">
                    <FontAwesomeIcon icon={faCheck} className="text-primary" />
                    <p className="font-size-20 lh-23 p-0 m-0">
                      {translationFallback(
                        'qualityMaintenanceDescription',
                        t('qualityMaintenanceDescription'),
                        'At Spiritory, we maintain consistent quality by following guidelines for the condition of all bottles sold on our platform.'
                      )}
                    </p>
                  </div>
                </div>

                <div className="d-flex align-items-center flex-wrap gap-3 mt-3">
                  <div
                    style={{ maxWidth: 300 }}
                    onClick={() => {
                      if (user) {
                        router.push('/dashboard');
                      } else {
                        router.push('/auth/sign-in');
                      }
                    }}
                  >
                    <button
                      className={`d-flex align-items-center gap-2 btn btn-s-outline-primary px-7`}
                      style={{ padding: '0.7rem 0' }}
                      type="button"
                    >
                      <span>
                        <FontAwesomeIcon icon={faRightToBracket} />
                      </span>
                      {translationFallback('logInButton', t('logInButton'), 'Log In')}
                    </button>
                  </div>
                  <div
                    style={{ maxWidth: 300 }}
                    onClick={() => {
                      if (user) {
                        router.push('/dashboard');
                      } else {
                        router.push('/auth/sign-up');
                      }
                    }}
                  >
                    <button
                      className={`d-flex align-items-center gap-2 btn btn-s-primary px-7`}
                      style={{ padding: '0.7rem 0' }}
                      type="button"
                    >
                      <span>
                        <FontAwesomeIcon icon={faUserPlus} />
                      </span>
                      {translationFallback('signUpButton', t('signUpButton'), 'Sign Up')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.mainImageContainer}>
              <Image
                src={mainBannerImage}
                alt="example"
                width={1000}
                height={1000}
                sizes="100vw"
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </div>
          </div>
        </div>

        <div
          className={`d-flex justify-content-center align-items-center position-relative my-8 ${styles.assureThat}`}
        >
          <div
            className={`d-flex align-items-center gap-6 px-5 px-sm-6 py-5 ${styles.conditionFirstContainer}`}
            style={{
              backgroundColor: 'rgba(28, 92, 235, 0.1)',
              maxWidth: '1246px',
              minHeight: '234px',
              borderRadius: '16px',
              border: '2px solid #8DADF5',
              position: 'relative',
            }}
          >
            <div className="d-flex align-items-center gap-7" style={{ width: '40%' }}>
              <div style={{ position: 'relative' }}>
                <Image
                  src="/images/condition-guide/Icon2.png"
                  alt="Icon"
                  width={92}
                  height={91.3}
                />
              </div>
              <div
                style={{
                  width: '2px',
                  height: '148px',
                  backgroundColor: '#DEDFE2',
                }}
              ></div>
            </div>
            <div className="ml-4" style={{ position: 'relative' }}>
              <p
                style={{
                  fontWeight: '700',
                  fontSize: '32px',
                  marginBottom: '20px',
                }}
              >
                {translationFallback(
                  'listingSellingGuidelines',
                  t('listingSellingGuidelines'),
                  'Before listing or selling, please ensure that your bottle coheres with our guidelines'
                )}
              </p>
              <p
                style={{
                  fontWeight: '500',
                  fontSize: '20px',
                  lineHeight: '25.2px',
                }}
              >
                {translationFallback(
                  'boxBottleCondition',
                  t('boxBottleCondition'),
                  "The condition of the box is as important as the condition of the bottle. That's why we make sure both are in MINT condition."
                )}
              </p>
            </div>
          </div>
        </div>

        <div>
          <div
            className="position-relative my-8 container text-center px-2 px-sm-12 py-6 py-sm-4"
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <h2 style={{ fontFamily: 'Prata', fontSize: '36px' }}>
              {translationFallback(
                'tradingBottleRequirements',
                t('tradingBottleRequirements'),
                'All bottles traded on Spiritory must be:'
              )}
            </h2>

            <div className={styles.mustBe}>
              <div>
                <div>
                  <Image
                    src={originalCapImage}
                    alt="Unopened with original cap or cork"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="Unopened with original cap or cork"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'unopened',
                    t('unopened'),
                    'Unopened with original cap or cork'
                  )}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={sealImage}
                    alt="With original and unopened seal"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="With original and unopened seal"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'unopenedSeal',
                    t('unopenedSeal'),
                    'With original and unopened seal'
                  )}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={neckImage}
                    alt="Filling in neck"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image src={greenTick} alt='Filling "in neck"' width={50} height={50} />
                </div>
                <b className={`p-3`}>
                  {translationFallback('fillingInNeck', t('fillingInNeck'), 'Filling "in neck"')}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={conditionImage}
                    alt="The label in a complete, stainless and bleachless condition"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="The label in a complete, stainless and bleachless condition"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'bleachless_condition',
                    t('bleachless_condition'),
                    'The label in a complete, stainless and bleachless condition'
                  )}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={ninelabelImage}
                    alt="For bottles released before 2000, preserve at least 90% of the label"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="For bottles released before 2000, preserve at least 90% of the label"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'ninetyPercentLabel',
                    t('ninetyPercentLabel'),
                    'For bottles released before 2000, preserve at least 90% of the label'
                  )}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={packagingImage}
                    alt="With the original packaging, that the bottle was released with"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="With the original packaging, that the bottle was released with"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'originalPackaging',
                    t('originalPackaging'),
                    'With the original packaging, that the bottle was released with'
                  )}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={magazineImage}
                    alt="If bottle were add-ons (magazine, etc.), they have to be included"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="If bottle were add-ons (magazine, etc.), they have to be included"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'addOnsIncluded',
                    t('addOnsIncluded'),
                    'If bottle were add-ons (magazine, etc.), they have to be included'
                  )}
                </b>
              </div>
              <div>
                <div>
                  <Image
                    src={whiskeyFriendly}
                    alt="Stored in whisky friendly conditions"
                    width={321}
                    height={228}
                    className={`${styles.imground}`}
                  />
                  <Image
                    src={greenTick}
                    alt="Stored in whisky friendly conditions"
                    width={50}
                    height={50}
                  />
                </div>
                <b className={`p-3`}>
                  {translationFallback(
                    'whiskyFriendly',
                    t('whiskyFriendly'),
                    'Stored in whisky friendly conditions'
                  )}
                </b>
              </div>
            </div>
          </div>
        </div>

        <div className="position-relative my-8" style={{ color: '#FFFFFF' }}>
          <Image
            src="/images/sell-guide/last.jpg"
            alt="example"
            width={0}
            height={0}
            sizes="100vw"
            style={{
              width: '100%',
              height: '352px',
              objectFit: 'cover',
            }}
            className=""
          />
          <div className="position-absolute top-50 start-50 translate-middle text-center">
            <h2 className="h2">
              {translationFallback(
                'noAccountYet',
                t('noAccountYet'),
                'You don’t have account yet?'
              )}
            </h2>
            <h4>{translationFallback('noAccountYet', t('noAccountYet'), 'Create it right now')}</h4>
            <button
              className={`btn btn-light font-size-20 lh-25 mt-6 ${styles.whiteBtn} ${styles.customButton2}`}
            >
              <div
                onClick={() => {
                  if (user) {
                    router.push('/dashboard');
                  } else {
                    router.push('/auth/sign-up');
                  }
                }}
                style={{ textDecoration: 'none' }}
              >
                {translationFallback('signUpNow', t('signUpNow'), 'Sign up Now')}
              </div>
            </button>
          </div>
        </div>

        <div className="container px-2 px-sm-8 py-6 py-sm-4 position-relative my-8">
          <div className={`h3 ${styles.bold} text-center`}>
            {translationFallback('faqTitle', t('faqTitle'), 'Frequently asked questions')}
          </div>

          <Accordion defaultActiveKey="0" className={'my-4'}>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <b>
                  {translationFallback(
                    'authenticationFailure',
                    t('authenticationFailure'),
                    'What happens, if the authentication fails?'
                  )}
                </b>
              </Accordion.Header>

              <Accordion.Body>
                {translationFallback(
                  'rejectionNoticeExplanation',
                  t('rejectionNoticeExplanation'),
                  "In that case, you'll get a rejection notice for the transaction. If the authentication fails, the bottle does not meet all the conditions of the bottle state, which you can learn more about here."
                )}
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <b>
                  {translationFallback(
                    'unsureAboutBottle',
                    t('unsureAboutBottle'),
                    "What can I do if I'm unsure if my bottle will pass?"
                  )}
                </b>
              </Accordion.Header>

              <Accordion.Body>
                {translationFallback(
                  'unsureAboutBottleExplanation',
                  t('unsureAboutBottleExplanation'),
                  "What can I do if I'm unsure if my bottle will pass?"
                )}
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <b>
                  {translationFallback(
                    'whySpiritoryCool',
                    t('whySpiritoryCool'),
                    'Why Is Spiritory so cool?'
                  )}
                </b>
              </Accordion.Header>

              <Accordion.Body>
                {translationFallback(
                  'uniquePlatformQuality',
                  t('uniquePlatformQuality'),
                  'Because it is the only platform where such high quality standard to the bottles and the possibility of reselling and investing in them'
                )}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>
    </>
  );
}

export const getStaticProps = getBasicStaticSideProps(['common', 'condition_guide', 'index']);

export default Authenticating;
